<template>
  <div id="app-center">
    <div class="center-box">
      <div class="center-left">
        <div class="avatar-box">
          <img src="../../assets/images/big_logo.png" alt />
        </div>
        <div class="nav-box">
          <ul>
            <li
              v-for="(item,index) in navList"
              :key="index"
              @click="getNav(item.id,item.rouertName)"
              :class="{active:navStatus==item.id}"
              v-if="item.isshow==true"
            >
              <p :class="{active:navStatus==item.id}"></p>
              <i class="iconfont" :class="item.icon"></i>
              {{item.name}}
              <span></span>
            </li>
          </ul>
        </div>
        <div class="logo-box">
          <!-- <img src="../../assets/images/logo.png" alt> -->
        </div>
      </div>
      <div class="center-right">
        <div class="r-heard">
          <P>HI~{{timeStr}}</P>
          <div class="time-box">
            <p>
              {{time}}
              <span>{{date}}</span>
            </p>
            <h5 class="iconfont icon-tuichu" @click="ttt">退出</h5>
          </div>
        </div>
        <div class="r-content">
          <router-view></router-view>
          <p>粤ICP备08034243号-20 COPYRIGHT ©2019 顺丰公益 技术支持: 普益云</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { timeString, format } from "@/libs/date";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      info:{},
      time:format("hh:mm:ss"),
      date: format("yyyy/MM/dd"),
      timeStr: "",
      navStatus: 1,
      navList: [
        {
          id: 1,
          name: "首页",
          isshow: true,
          rouertName: "centerHomeIndex"
        },

        // {
        //   id: 7,
        //   name: "资助学生维护",
        //   icon: "icon-fenlei",
        //   isshow: this.$store.state.user_info.teacher ? true : false,
        //   rouertName: "centerCollegeSupport"
        // }
      ],
      trainList: [
        {
          id: 1,
          title: "2019级项目成员岗前培训成长",
          content:
            "感谢各大高校社团及义工对为中国而教校园招募宣讲会的鼎力支持。"
        },
        {
          id: 1,
          title: "2018级项目成员岗前培训成长",
          content:
            "因为你们，我们多了一份继续前行的力量！ 感谢对中国教育公平与公益事业的支持！"
        },
        {
          id: 1,
          title: "2017级项目成员岗前培训成长",
          content:
            "感谢各大高校社团及义工对为中国而教校园招募宣讲会的鼎力支持。"
        }
      ],
      termList: [
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    ttt() {
      let data = {
        user: null,
        token: {
          access_token: null
        }
      };
      this.setUserInfo(data);
      this.$router.push({ name: "home" });
    },
    getNav(id, name) {
      this.navStatus = id;
      this.$router.push({ name: name });
    }
  },
  mounted() {
    this.$db.get(this.$url.user.url).then(resp=>{
        this.info = resp.data;
        this.navList.push(
          {
            id: 2,
            name: "基本信息",
            isshow: true,
            rouertName: "centerUserIndex"
          },
          {
            id: 6,
            name: "活动信息",
            isshow: (this.info.college_student_id || this.info.identity_type==1)?true:false,
            rouertName: "centerActivityList"
          },
          {
            id: 3,
            name: "走访记录",
            isshow: true,
            rouertName: "centerVisitIndex"
          },
          {
            id: 5,
            name: "本专科奖学金审核",
            isshow: this.$store.state.user_info.college_manager ? true : false,
            rouertName: "studentUniversity"
          },
          {
            id: 97,
            name: "硕士奖学金审核",
            isshow: this.$store.state.user_info.college_manager ? true : false,
            rouertName: "studentMaster"
          },
          {
            id: 98,
            name: "博士奖学金审核",
            isshow: this.$store.state.user_info.college_manager ? true : false,
            rouertName: "studentDr"
          },
          {
            id: 9,
            name: "学校信息维护",
            isshow: this.$store.state.user_info.teacher ? true : false,
            rouertName: "schoolInfo"
          },
          {
            id: 8,
            name: "资助学生管理",
            isshow: this.$store.state.user_info.teacher ? true : false,
            rouertName: "centerSupportUsers"
          },
          {
            id: 11,
            name: "助学金发放台账",
            isshow: this.$store.state.user_info.teacher ? true : false,
            rouertName: "studentAccounts"
          },
        )
    })
    let _this = this
    this.timeStr = timeString();
    setInterval(function() {
      _this.time =  format("hh:mm:ss");
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
#app-center {
  // width: 100%;
  height: 100%;
}
.center-box {
  width: 100%;
  height: 100%;
  display: flex;
  .center-left {
    // background-color: #f00;
    height: 100%;
    width: 16.666666666666666vw;
    box-shadow: 0px 0px 49px 0px rgba(0, 1, 3, 0.11);
    background: url(../../assets/images/left_bg.png) no-repeat bottom;
    background-size: 100%;
    position: relative;
    border-right: solid 1px #e4e5e9;
    > h5 {
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
      color: #414c60;
      font-weight: normal;
      text-align-last: center;
      margin-top: 3.888888888888889vh;
    }
    .avatar-box {
      text-align: center;
      margin-top: 1.4814814814814815vh;
      > img {
        height: 11.285185185185185vh;
        width: 5.7291666666666664vw;
        overflow: hidden;
        /*border-radius: 50%;*/
      }
      > p {
        color: #8d95a4;
        font-size: 1.4814814814814815vh;
        line-height: 1.4814814814814815vh;
        margin-top: 1.0814814814814815vh;
      }
    }
    .nav-box {
      margin-top: 4.1666666666666664vh;
      > ul {
        > li {
          list-style: none;
          height: 5.740740740740741vh;
          line-height: 5.740740740740741vh;
          position: relative;
          cursor: pointer;
          color: #8d95a4;
          padding-left: 4.0625vw;
          &.active {
            color: #414c60;
          }
          &:hover {
            > span {
              &::before {
                width: calc(100% - 0.3125vw);
                border-left: 0.3125vw solid #1caee0;
              }
            }
          }
          > p {
            width: calc(100% - 0.3125vw);
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            &.active {
              border-left: 0.3125vw solid #1caee0;
              background-color: rgba($color: #1caee0, $alpha: 0.1);
            }
          }
          > i {
            font-style: normal;
            position: absolute;
            left: 2.6041666666666668vw;
            top: 47%;
            transform: translateY(-50%);
            color: #8d95a4;
          }
          > span {
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 0;
              height: 100%;
              background-color: rgba($color: #1caee0, $alpha: 0.08);
              transition: all 0.7s ease;
            }
          }
        }
      }
    }
    .logo-box {
      //width: 14.114583333333333vw;
      //height: 5.6vh;
      position: absolute;
      bottom: 5.740740740740741vh;
      left: 50%;
      transform: translateX(-50%);
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .center-right {
    width: 83.33333333333334%;
    height: 100%;
    .r-heard {
      width: 100%;
      height: 9.259259259259259vh;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #e4e5e9;
      > p {
        line-height: 9.259259259259259vh;
        padding-left: 2.5vw;
        color: #414c60;
        font-size: 2.2222222222222223vh;
      }
      .time-box {
        display: flex;
        > p {
          line-height: 9.259259259259259vh;
          font-size: 3.333333333333333vh;
          color: #8d95a4;
          padding: 0 1.3541666666666667vw;
          border-left: solid 1px #e4e5e9;
          > span {
            font-size: 1.4814814814814815vh;
          }
        }
        > h5 {
          font-weight: normal;
          font-size: 1.6666666666666666vh;
          line-height: 9.259259259259259vh;
          color: #8d95a4;
          padding: 0 1.5625vw;
          border-left: solid 1px #e4e5e9;
          cursor: pointer;
        }
      }
    }
    .r-content {
      padding: 0 2.1875vh 0 2.5vw;
      overflow: hidden;
      height: 90.64074074074074vh;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      // padding-bottom: 11.11111111111111vh;
      &::-webkit-scrollbar {
        display: none;
      }

      > p {
        font-size: 1.2962962962962963vh;
        color: #b4b7be;
        text-align: center;
        margin-bottom: 3.2407407407407406vh;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Center/index.vue